import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const informationTableClasses = tv({
	slots: {
		base: 'grid grid-cols-4 lg:grid-cols-6 col-span-4 md:col-span-6 2xl:max-w-[172rem] 2xl:mx-auto',
		tagText: 'col-span-4 lg:col-span-6',
		header: 'col-span-4 lg:col-span-6 grid grid-cols-4 lg:grid-cols-6 items-end mt-1 lg:mt-2',
	},
})

export type InformationTableVariants = VariantProps<typeof informationTableClasses>
